export const PUBLIC_PATHS = [
  '/login',
  '/confirm-account',
  '/reset-password',
  '/public/confirm-activity',
]

export function isPublicPath(path: string): boolean {
  return PUBLIC_PATHS.some(
    (allowed) => path === allowed || path.startsWith(`${allowed}/`)
  )
}

export type NavigationDecision =
  | { type: 'wait' }
  | { type: 'allow' }
  | { type: 'redirect'; to: string }

/**
 * Decide where the user may go. Public email-link routes (confirm activity)
 * must work for both anonymous and authenticated visitors.
 */
export function resolveNavigation(options: {
  authLoading: boolean
  isAuthenticated: boolean
  userType?: string | null
  path: string
}): NavigationDecision {
  const { authLoading, isAuthenticated, userType, path } = options

  if (isPublicPath(path)) {
    return { type: 'allow' }
  }

  if (authLoading) {
    return { type: 'wait' }
  }

  if (isAuthenticated) {
    if (!userType) {
      return { type: 'redirect', to: '/login' }
    }
    const home = `/${userType.toLowerCase()}`
    if (path === home || path.startsWith(`${home}/`)) {
      return { type: 'allow' }
    }
    return { type: 'redirect', to: home }
  }

  return { type: 'redirect', to: '/login' }
}
